// @ts-expect-error: This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin
// See configuration in webpack.config.js
import SelectPassengerList from "./SelectPassengerList-APP_CLIENT";

export default SelectPassengerList;
